import { useContext } from "react";
import { BoundaryContext } from "./BoundaryContext";

export const useBoundaries = () => {
  const context = useContext(BoundaryContext);

  if (!context) {
    throw new Error("useBoundaries must be used within a BoundaryProvider");
  }

  return context;
};
